// extracted by mini-css-extract-plugin
export var askAiIcon = "_ko-9";
export var container = "_ko-0";
export var groupSeparator = "_ko-a";
export var highlight = "_ko-4";
export var resultIcon = "_ko-5";
export var resultItem = "_ko-7";
export var resultSubtitle = "_ko-3";
export var resultTitle = "_ko-2";
export var resultsList = "_ko-1";
export var searchGroup = "_ko-6";
export var selected = "_ko-8";